import { ClientFormInput, ClientFormInputWithToAgencyInput } from 'src/types';

export type SuccessHomeToStoreSubmit = {
  clientOrderId: string;
  tel: string;
};
export type HomeToStoreAgencyInfo = {
  name: string;
  slug: string;
  tel: string;
  address: string;
  lat: number;
  lang: number;
  zip?: string;
  city: {
    name: string;
    country: {
      name: string;
      code: string;
    };
  };
};

export type HomeToStoreSubmitDataState = {
  isLoading: boolean;
  error: Error | null;
  success: SuccessHomeToStoreSubmit | null;
};

export type HomeToStoreClientRequestForm = {
  sender: ClientFormInput;
  receiver: ClientFormInput;
  senderIsNotReceiver: boolean;
  colisNumber: number;
  description: string;
  toAgency: string;
};

export type HomeToStoreInitialState = {
  agency: HomeToStoreAgencyState;
  form: HomeToStoreClientRequestForm;
  submitData: HomeToStoreSubmitDataState;
  marketingAgencyId?: string;
};

export type HomeToStoreAgencyState = {
  isLoading: boolean;
  error: Error | null;
  info: HomeToStoreAgencyInfo | null;
  agencies: HomeToStoreAgencyInfo[];
};

export type HomeToStoreSetAgencyLoader = {
  isLoading: boolean;
};

export type HomeToStoreSetAgencyError = {
  error: Error | null;
};

export type HomeToStoreSetAgencyInfo = {
  info: HomeToStoreAgencyInfo | null;
};

export type HomeToStoreSetAgenciesList = {
  agencies: HomeToStoreAgencyInfo[];
};

export const START_LOADING_HOME_TO_STORE_AGENCY_INFO = 'HomeToStore/start/loadingAgency';

export const HOME_TO_STORE_SUBMIT_DATA_INFO = 'home/to/store/start/submit/data/info';

export type HomeToStoreStartLoadingAgencyInfoAction = {
  type: typeof START_LOADING_HOME_TO_STORE_AGENCY_INFO;
  slug: string;
};

export type HomeToStoreStartSubmitFormData = {
  type: typeof HOME_TO_STORE_SUBMIT_DATA_INFO;
};

export type SetHomeToStoreSenderAction = {
  sender: ClientFormInputWithToAgencyInput;
};

export type SetHomeToStoreReceiverAction = {
  receiver: ClientFormInput;
};

export type SetHomeToStoreSenderIsNotReceiverAction = {
  senderIsNotReceiver: boolean;
};

export type SetHomeToStoreColisNumberAndDescriptionAction = {
  colisNumber: number;
  description: string;
};

export type SetHomeToStoreSubmitDataSetLoaderAction = {
  isLoading: boolean;
};

export type SetHomeToStoreSubmitDataSetErrorAction = {
  error: Error | null;
};

export type SetHomeToStoreSubmitDataSetSuccessAction = {
  success: SuccessHomeToStoreSubmit | null;
};
